
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Rutherford_classification_of_lower_limb_arteriosclerosis_obliterans',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Rutherford_classification_of_lower_limb_arteriosclerosis_obliterans.vue